import { pathOr } from 'ramda';

import { RootState } from '../reducers';

export const userIdSelector = (state: RootState): number | null => pathOr(null, ['me', 'id'], state.me);
